<template>
    <div class="reg-temp-content-area p-3 main-content-height">
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <p class="text-left mt-2">
                    <router-link class="btn btn-primary px-5 gap-2" :to="{name: 'DistributorCustomerAdd', query: {redirect: 'DistributorResellers'}}">
                        <i class="fa fa-plus"></i> Add New User
                    </router-link>
                </p>
            </div>

            <div class="col-sm-12 col-md-12 mb-2">
                <div class="row justify-content-between">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <input
                            class="search-input top-search-input"
                            :disabled="loading == true"
                            v-model="s"
                            placeholder="Search by Email / Company / Name "
                        />
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-12 text-center" v-if="loading">
                <loading />
            </div>

            <template v-else>
                <div class="col-sm-12 col-md-12 mb-2">
                    <pagination class="mt-0" :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination>
                </div>

                <div class="col-sm-12 col-md-12" v-if="resellers.length == 0 && mountLoadingCount > 0">
                    <p class="text-center mt-5">No reseller found.</p>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3" v-bind:key="'reseller_' + index" v-for="(reseller, index) in resellers">
                    <reseller-item :editcallback="editCallBack" :deletecallback="deleteCallBack" :user="reseller" />
                </div>

                <div class="col-sm-12 col-md-12 mt-3">
                    <pagination class="mt-0" :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination>
                </div>
            </template>
        </div>

        <!-- <pagination class="mt-0" :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination>
      <vue-good-table
        :columns="columns"
        :search-options="{
          enabled: true
        }"
      :rows="rows">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'action'" class="table-action-wrapper">
            <router-link :to="{ name: 'DistributorRegisteredProducts', query: { customer_id: props.row.id, role: 'reseller'}}" class="edit-action"><i class="fab fa-product-hunt"></i></router-link>
            <router-link :to="{ name: 'DistributorCustomerEdit', params: { customer_id: props.row.id }, query: { role: 'reseller'}}" class="edit-action"><i class="fas fa-pencil-alt"></i></router-link>
            <a href="#" @click.prevent="deleteThis(props.row)" class="delete-action"><i aria-hidden="true" class="fa fa-trash"></i></a>
          </span>
          <span v-else-if="props.column.field == 'regproduct'">
            <div v-if="props.row.registered_products.length > 0">
              <span v-bind:key="regp.id" v-for="regp in props.row.registered_products">{{ regp.serial_number }} / {{ regp.coc_number }}<br/></span>
            </div>
            <span v-else>0</span>
          </span>
        </template>
      </vue-good-table>  
      <pagination :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination> -->
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import Pagination from '@/components/Pagination';
import {mapGetters, mapActions} from 'vuex';

export default {
    name: 'distributorCustomerList',
    components: {
        Pagination
    },
    data() {
        return {
            s: '',
            customerType: 'reseller',
            pdfdata: '',
            loading: false,
            currentPage: 1,
            pageNavs: [],
            resellers: [],
            mountLoadingCount: 0
        };
    },
    watch: {
        customerType() {
            this.currentPage = 1;
            this.fetchReseller();
        },
        '$route.params': {
            handler: function () {},
            deep: true,
            immediate: true
        },
        s(val) {
            this.currentPage = 1;
            this.fetchReseller();
        }
    },

    mounted() {
        this.fetchReseller();
    },

    methods: {
        /**
         * Fetch reg products
         */
        fetchReseller: _.debounce(function () {
            this.loading = true;
            const url = `${Env.baseUrl}/distributor/customers/list?page=${this.currentPage}&role=${this.customerType}&s=${this.s}`;
            AuthApis.getApi(url)
                .then((res) => {
                    this.mountLoadingCount = 1;
                    this.resellers = res.data.payload;
                    this.pageNavs = res.data.nav;
                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
        }, 1000),
        /**
         * Fetch page data
         */
        fetchPage(pageNo) {
            this.currentPage = pageNo;
            this.fetchReseller();
        },

        deleteCallBack(obj) {
            this.$confirm({
                title: `DELETE?`,
                message: 'Are you sure you want to delete ' + obj.email,
                button: {
                    no: 'No',
                    yes: 'Yes'
                },
                callback: (confirm) => {
                    if (confirm) {
                        const url = `${Env.baseUrl}/distributor/customers/delete/${obj.id}`;
                        AuthApis.deleteApi(url)
                            .then(async (res) => {
                                this.fetchReseller();
                                this.$toasted.global.success({
                                    message: 'Successfully deleted.'
                                });
                            })
                            .catch((err) => {
                                this.$toasted.global.error({
                                    message: 'Failed, please try again later.'
                                });
                            });
                    }
                }
            });
        },

        editCallBack(user) {
            this.$router.push({
                name: 'DistributorCustomerEdit',
                params: {
                    customer_id: user.id
                }
            });
        },

        viewCocCertificate(obj) {
            this.va_pdfModal(true);
            this.va_pdfModalObj(obj);
        },

        ...mapActions({
            va_setDeleteModal: 'distributor_customer/setDelete',
            va_setDeleteObj: 'distributor_customer/setDeleteObj',
            va_setEditModal: 'distributor_customer/setEdit',
            va_setEditObj: 'distributor_customer/setEditObj',
            va_pdfModal: 'pdf/setActive',
            va_pdfModalObj: 'pdf/setActiveObj'
        })
    }
};
</script>
